import React, {useState} from "react";
import { Box } from "react-bulma-components";
import { Form } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import useInput from "../../hooks/useInput";
import { Button } from "react-bulma-components";
import Collapsible from "react-collapsible";
import axios from "axios";
import {asyncContainer, Typeahead} from "react-bootstrap-typeahead";
import { Icon } from "react-bulma-components";
import {NotificationManager} from "react-notifications";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh} from "../../state/selectors";
import CreatedModal from "./CreatedModal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPoundSign} from "@fortawesome/free-solid-svg-icons";
import PaymentTypePicker from "../Settings/PaymentTypes/PaymentTypePicker";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";
import VatSelector from "../Utils/VatSelector";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import TaxTypePicker from "../Settings/NominalCodes/TaxTypePicker";
import NominalCodePicker from "../Settings/NominalCodes/NominalCodePicker";

const AsyncTypeahead = asyncContainer(Typeahead);

function NewTransaction({endpoint, type, paymentTypes, departments, departmentObjects, trackingOptions, trackingOptionObjects, nominalCodes, nominalObjects}) {
  const dataFresh = useSelector(getDataFresh);
  const [createdId, setCreatedId] = useState();
  const [createdModalOpen, setCreatedModalOpen] = useState(false);
  const dispatch = useDispatch();

  const accountOptions = [
    { name: "", value: "BLANK"},
    { name: "Hire", value: "hire_account_code"},
    { name: "Sale", value: "sale_account_code"},
    { name: "Workshop", value: "workshop_account_code"},
    { name: "Deposit", value: "deposit_account_code"},
    { name: "Loan", value: "loan_account_code"},
    { name: "Part", value: "part_account_code"},
    { name: "Court", value: "court_account_code"},
    { name: "Movement", value: "movement_account_code"}
  ];


  const paymentTypeObjects = paymentTypes ? paymentTypes.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : {};
  const inout_mapping = {"OUT": "SP", "IN": "CC"};
  const type_mapping = {"OUT": "Outgoing", "IN": "Incoming"};

  const handleCustomerAccountChange = e => {
    setCustomerAccount(e.target.value);
  }

  const handleNominalCodeChange = e => {
    setNominalCode(nominalObjects[e.target.value])
  }


  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [contact, setContact] = useState({});
  const [, setTypeahead] = useState();

  const handleSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=${inout_mapping[type]}&page_size=40&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  };

  const handleContactSelect = contact => {
    setContact(contact[0]);
  };

  const handleTrackingOptionChange = e => {
    setTrackingOption(trackingOptionObjects[e.target.value]);
  }

  const [description, descriptionInput, setDescription] = useInput({
    type: "text",
    label: "Description"
  });
  const [paymentType, setPaymentType] = useState(type === "OUT"? paymentTypeObjects[Object.keys(paymentTypeObjects)[0]] : null);
  const [comments, commentsInput, setComments] = useInput({
    type: "text",
    label: "Comments"
  });
  const [invoiceNumber, invoiceNumberInput, setInvoiceNumber] = useInput({
    type: "text",
    label: "Invoice Number"
  });

  const [customerAccount, setCustomerAccount] = useState(accountOptions[0]['value']);
  const [nominalCode, setNominalCode] = useState({});
  const [trackingOption, setTrackingOption] = useState(trackingOptions.results[0]);
  const [ignoreFigure, setIgnoreFigure] = useState(false);

  const [department, setDepartment] = useState({id: 1, name: "Rentals Direct"})

  const [repeating, setRepeating] = useState(false);
  const [frequency, setFrequency] = useState("");
  const [amount, amountInput, setAmount] = useInput({
    type: "number",
    label: "Amount",
    currency: true
  });

  const [invoice_amount, invoiceAmountInput, setInvoiceAmount] = useInput({
    type: "number",
    label: "Invoice Amount",
    currency: true
  });
  const [invoice_vat, setInvoiceVat] = useState("INPUT2");
  const [invoice_date, invoiceDateInput, setInvoiceDate] = useInput({
    type: "date",
    label: "Invoice Date",
    initialValue: null
  });
  const [date, dateInput, setDate] = useInput({
    type: "date",
    label: "Date",
    initialValue: null
  });

  const handleSubmit = () => {
    if (!repeating && (!date || !description || !amount)) {
      NotificationManager.warning("You must specify an Invoice Date, Description and Amount!",
        "Missing fields",
        10000)
    } else if (!description || !amount) {
      NotificationManager.warning("You must specify a Description and Amount!",
        "Missing fields",
        10000)
    } else {
      const url = endpoint + "transactions";
      const conf = {
        method: "post",
        data: {
          description,
          customer_account: customerAccount,
          comments,
          type,
          amount,
          date: date || null,
          invoice_date: invoice_date || null,
          invoice_amount: invoice_amount || 0,
          invoice_vat: invoice_vat || 0,
          repeating: repeating,
          frequency: frequency,
          invoice_number: invoiceNumber,
          contact: contact,
          payment_type: paymentType,
          tracking_option: trackingOption || null,
          department: department,
          nominal_code: nominalCode,
          ignore_in_figures: ignoreFigure
        },
        url
      };

      return axios(conf).then((res) => {
        dispatch(createSetDataFreshAction(dataFresh + 1));
        setCreatedModalOpen(true);
        setCreatedId(res.data.id);
        setDescription("");
        setInvoiceDate("");
        setDate("");
        setAmount(0);
        setContact({});
        setInvoiceNumber("");
        setInvoiceAmount(0);
        setInvoiceVat(0);
        setComments("");
        setTrackingOption(null)
        setPaymentType(type === "OUT" ? paymentTypeObjects[Object.keys(paymentTypeObjects)[0]] : null)
        setDepartment({id: 1, name: "Rentals Direct"});
        setIgnoreFigure(false);
      }).catch(() => {
        NotificationManager.error(
          "An error occured",
          "Error!",
          10000
        );
      });

    }
  };

  const onDepartmentChange = e => {
    setDepartment(departmentObjects[e.target.value]);
  }

  return (
    <Box>
      <Collapsible
        className="title"
        triggerOpenedClassName="title"
        trigger={"Add" + ` ${type_mapping[type]}` + " Transaction"}
      >
        <Columns>
          <Columns.Column>
            <Form.Field className="has-addons">
              <Form.Control>
                <Form.Label>Repeating</Form.Label>
                <Button
                  color={repeating ? "primary" : ""}
                  onClick={() => setRepeating(true)}
                >
                  Yes
                </Button>
                <Button
                  color={!repeating ? "primary" : ""}
                  onClick={() => {
                    setRepeating(false);
                    setFrequency("")
                  }}
                >
                  No
                </Button>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          {repeating &&
          <Columns.Column>
            <Form.Field className="has-addons">
              <Form.Control>
                <Form.Label>Frequency</Form.Label>
                <Button
                  color={frequency === "WEEKLY" ? "primary" : ""}
                  onClick={() => setFrequency("WEEKLY")}
                >
                  Weekly
                </Button>
                <Button
                  color={frequency === "MONTHLY" ? "primary" : ""}
                  onClick={() => setFrequency("MONTHLY")}
                >
                  Monthly
                </Button>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          }
          {descriptionInput}
          <Columns.Column>
            <Form.Field>
              <Form.Label>Contact</Form.Label>
              <AsyncTypeahead
                id="typeahead"
                labelKey="display_name"
                minLength={2}
                name={"contact"}
                onSearch={handleSearch}
                onChange={handleContactSelect}
                placeholder={"Search Contact"}
                options={searchData}
                ref={typeahead => setTypeahead(typeahead)}
                className="typeahead"
                useCache={false}
                isLoading={isLoading}
                selected={
                  contact && contact.id ? [contact] : []
                }
              />
            </Form.Field>
          </Columns.Column>
          {type === "IN" &&
            <Columns.Column>
              <Form.Label>Customer Account</Form.Label>
              <Form.Select
                name={"customer_account"}
                disabled={false}
                value={customerAccount}
                onChange={handleCustomerAccountChange}
              >
                {accountOptions.map((option) => (
                    <option value={option.value}>{option['name']}</option>
                ))}
              </Form.Select>
            </Columns.Column>
          }
          {commentsInput}
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <TrackingOptionsPicker
                  inlineEdit={false}
                  label={"Tracking Category"}
                  name={"tracking_option"}
                  options={trackingOptions}
                  onChange={handleTrackingOptionChange}
                  editable={true}
                  blank={false}
                  value={trackingOption}
                  className={"no-small"}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <DepartmentSelector
              options={departments}
              name={"department"}
              inlineEdit={false}
              editable={true}
              classname={""}
              disabled={false}
              value={department}
              onChange={onDepartmentChange}
              blank={false}
              label={"Department"}
            />
          </Columns.Column>

        </Columns>
        <Columns>
          {amountInput}
          <Columns.Column size={2}>
            <NominalCodePicker
              label={"Nominal Code"}
              name={"nominal_code"}
              value={nominalCode}
              options={nominalCodes}
              inlineEdit={false}
              disabled={false}
              editable={true}
              onChange={handleNominalCodeChange}
              blank={true}
              small={false}
            />
          </Columns.Column>

          {!repeating && dateInput}
          {type === "OUT" &&
              <Columns.Column>
                <Form.Label>Payment Type</Form.Label>
                <PaymentTypePicker
                  options={paymentTypes}
                  inlineEdit={false}
                  blank={false}
                  disabled={false}
                  onChange={(e) => setPaymentType(paymentTypeObjects[e.target.value])}
                  value={paymentType}
                />
              </Columns.Column>
          }
        </Columns>
        {!repeating &&
        <Columns>
          {invoiceAmountInput}
          <Columns.Column>
            <TaxTypePicker
              name={"invoice_vat"}
              label={"Invoice VAT"}
              value={invoice_vat}
              onChange={e => setInvoiceVat(e.target.value)}
            />
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Invoice Total</Form.Label>
              <Form.Control>
                <Form.Input
                  value={(invoice_amount * (1 + (invoice_vat / 100))).toFixed(2)}
                  type="number"
                  readonly
                  disabled
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>

          {invoiceNumberInput}
          {invoiceDateInput}
          <Columns.Column>
            <Form.Label>Remove from Figures</Form.Label>
            <Form.Checkbox
              checked={ignoreFigure}
              onChange={e => setIgnoreFigure(e.target.checked)}
              name={"ignore_in_figures"}
            />
          </Columns.Column>
        </Columns>
        }

        <Columns>
          <Columns.Column>
            <Button onClick={handleSubmit} fullwidth color={"success"}>
              Add
            </Button>
          </Columns.Column>
        </Columns>
      </Collapsible>
      <CreatedModal open={createdModalOpen} id={createdId} setOpen={setCreatedModalOpen}/>
    </Box>
  );
}

export default NewTransaction;
